import React, { useState } from "react";
import { Carousel, Modal } from "react-bootstrap";

function Carousal({ showModal, handleCloseModal, images }) {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  return (
    <Modal centered size="xl" show={showModal} onHide={handleCloseModal}>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <Carousel
          activeIndex={activeIndex}
          onSelect={handleSelect}
          interval={2000}
          nextIcon={<span className="carousel-control-next-icon" />}
          prevIcon={<span className="carousel-control-prev-icon" />}
        >
          {images.map((image, index) => (
            <Carousel.Item key={index}>
              <img src={image} alt={`${index + 1}`} className="carousal-img" />
            </Carousel.Item>
          ))}
        </Carousel>
      </Modal.Body>
    </Modal>
  );
}

export default Carousal;
